export default __webpack_public_path__ + "static/media/import.e401ba3b.svg";